import React from "react";

function AudioTime({ currentTime, audioTime }) {
  return (
    <div className="text-[10px] w-full !-mt-0 flex justify-between text-slate-400">
      <span>{currentTime}</span>
      <span>{audioTime}</span>
    </div>
  );
}

export default AudioTime;
